import { makeContextModule } from '@cian/react-utils';

import { ReplyScrollStore } from './ReplyScrollStore';

export const { Context: ReplyScrollStoreContext, useContext: useReplyScrollStoreContext } =
  makeContextModule<ReplyScrollStore>({
    contextName: 'ReplyScrollStoreContext',
  });
